module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            message: '@?',
        },
        template: '<div class="tooltipQuestionmark" oly-tooltip="message">?</div>',
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/tooltip/tooltip-questionmark.directive.js